// Reconstructed from production code; original paths and local names were not available.
import * as jsxRuntime from "react/jsx-runtime";
import { useLanguage } from "../context/LanguageContext.jsx";
const loadingVariants = new Set(["page", "section", "route", "admin"]);
const loadingLayouts = new Set([
  "focus",
  "home",
  "catalog",
  "product",
  "partners",
  "dashboard",
  "table",
]);
function defaultLoadingLabel() {
  if (typeof document < "u") {
    const l = document.documentElement.lang || "",
      i = document.documentElement.dir || "";
    if (l.toLowerCase().startsWith("ar") || i.toLowerCase() === "rtl")
      return "جارٍ التحميل…";
  }
  return "Loading…";
}
function LoadingPreview({ layout: layout }) {
  return layout === "focus" ? null : layout === "home" ? (
    <div
      className={"app-loading__preview app-loading__preview--home"}
      aria-hidden={"true"}
    >
      <div className={"app-loading__preview-hero"}>
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--eyebrow"
          }
        />
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--hero-title"
          }
        />
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--hero-copy"
          }
        />
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--hero-action"
          }
        />
      </div>
      <div className={"app-loading__preview-product-row"}>
        <span className={"app-loading__preview-product"} />
        <span className={"app-loading__preview-product"} />
        <span className={"app-loading__preview-product"} />
      </div>
    </div>
  ) : layout === "catalog" ? (
    <div
      className={"app-loading__preview app-loading__preview--catalog"}
      aria-hidden={"true"}
    >
      <div className={"app-loading__preview-toolbar"}>
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--search"
          }
        />
        <span
          className={"app-loading__placeholder app-loading__placeholder--chip"}
        />
        <span
          className={"app-loading__placeholder app-loading__placeholder--chip"}
        />
      </div>
      <div className={"app-loading__preview-card-grid"}>
        <span className={"app-loading__preview-product"} />
        <span className={"app-loading__preview-product"} />
        <span className={"app-loading__preview-product"} />
      </div>
    </div>
  ) : layout === "product" ? (
    <div
      className={"app-loading__preview app-loading__preview--product"}
      aria-hidden={"true"}
    >
      <span className={"app-loading__preview-media"} />
      <div className={"app-loading__preview-product-copy"}>
        <span
          className={"app-loading__placeholder app-loading__placeholder--title"}
        />
        <span
          className={"app-loading__placeholder app-loading__placeholder--copy"}
        />
        <span
          className={"app-loading__placeholder app-loading__placeholder--price"}
        />
        <span
          className={
            "app-loading__placeholder app-loading__placeholder--hero-action"
          }
        />
      </div>
    </div>
  ) : layout === "partners" ? (
    <div
      className={"app-loading__preview app-loading__preview--partners"}
      aria-hidden={"true"}
    >
      <span className={"app-loading__preview-logo"} />
      <span className={"app-loading__preview-logo"} />
      <span className={"app-loading__preview-logo"} />
      <span className={"app-loading__preview-logo"} />
    </div>
  ) : layout === "dashboard" ? (
    <div
      className={"app-loading__preview app-loading__preview--dashboard"}
      aria-hidden={"true"}
    >
      <div className={"app-loading__preview-metric-grid"}>
        <span className={"app-loading__preview-metric"} />
        <span className={"app-loading__preview-metric"} />
        <span className={"app-loading__preview-metric"} />
        <span className={"app-loading__preview-metric"} />
      </div>
      <div className={"app-loading__preview-list"}>
        <span />
        <span />
        <span />
      </div>
    </div>
  ) : (
    <div
      className={"app-loading__preview app-loading__preview--table"}
      aria-hidden={"true"}
    >
      <span className={"app-loading__preview-table-head"} />
      <span className={"app-loading__preview-table-row"} />
      <span className={"app-loading__preview-table-row"} />
      <span className={"app-loading__preview-table-row"} />
    </div>
  );
}
function AppLoading({
  variant: l = "page",
  layout: i = "focus",
  label: label,
  detail: detail,
  brand: brand,
  className: f = "",
}) {
  const { tText } = useLanguage();
  const m = loadingVariants.has(l) ? l : "page",
    y = loadingLayouts.has(i) ? i : "focus",
    g = tText(label || "Loading…"),
    p = [g, detail].filter(Boolean).join(" "),
    b = ["app-loading", `app-loading--${m}`, `app-loading--layout-${y}`, f]
      .filter(Boolean)
      .join(" ");
  return (
    <section
      className={b}
      role={"status"}
      aria-live={"polite"}
      aria-atomic={"true"}
      aria-busy={"true"}
      aria-label={p}
    >
      <span
        className={"app-loading__glow app-loading__glow--one"}
        aria-hidden={"true"}
      />
      <span
        className={"app-loading__glow app-loading__glow--two"}
        aria-hidden={"true"}
      />
      <div className={"app-loading__content"}>
        <div className={"app-loading__mark"} aria-hidden={"true"}>
          <span className={"app-loading__ring app-loading__ring--outer"} />
          <span className={"app-loading__ring app-loading__ring--middle"} />
          <span className={"app-loading__ring app-loading__ring--inner"} />
          <span className={"app-loading__spark app-loading__spark--one"} />
          <span className={"app-loading__spark app-loading__spark--two"} />
          <span className={"app-loading__core"}>
            <span />
          </span>
        </div>
        <div className={"app-loading__copy"} dir={"auto"}>
          {brand ? <span className={"app-loading__brand"}>{brand}</span> : null}
          <p className={"app-loading__label"}>{g}</p>
          {detail ? <p className={"app-loading__detail"}>{detail}</p> : null}
        </div>
        <LoadingPreview layout={y} />
        <span className={"app-loading__progress"} aria-hidden={"true"}>
          <span />
        </span>
      </div>
    </section>
  );
}
export {
  loadingVariants,
  loadingLayouts,
  defaultLoadingLabel,
  LoadingPreview,
  AppLoading,
};
